import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AppDate } from "@app/util/app-date";

@Component({
    selector: 'app-onetime-overlap-dialog',
    template: require('./onetimeOverlapDialog.html')
})
export class OneTimeOverlapDialog {
    currentDate: AppDate;
    amount: number;
    vendorItemNumber: number;
    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
        @Inject(MatDialogRef<OneTimeOverlapDialog>) public dialogRef: MatDialogRef<OneTimeOverlapDialog>) {
        this.currentDate = data.currentDate ? data.currentDate : AppDate.now();
        this.amount = data.amount ? data.amount : 0;
        this.vendorItemNumber = data.vendorItemNumber ? data.vendorItemNumber : 0;
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }
}
